import { api } from './api';

export async function getLevelPlayer() {
  const payload = {  };
  const { data } = await api.post(`find/get_level`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data[0];
  }
}
